
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-gb",
      function () {
        return require("private-next-pages/en-gb/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-gb"])
      });
    }
  